module.exports = __webpack_public_path__ + "img/heritage-store-new-product-launch-event.6cfb6bc4.jpg";